import "../../CommonImports";
import "../../Core/core.css";
import "./Card.css";
import * as React from "react";
import { SurfaceContext } from '../../Surface';
import { css } from '../../Util';
export const CardContent = props => {
    return (React.createElement(SurfaceContext.Consumer, null, surfaceContext => {
        const { contentPadding = true } = props;
        return (React.createElement("div", { className: css(props.className, "bolt-card-content flex-row flex-grow", contentPadding && surfaceContext.horizontalClassName) }, props.children));
    }));
};
